import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCreateNote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#007AFF">
      <path d="M13.5 20V7M7 13.5h13M1 26h18.576L26 19.576V1H1z" />
      <path d="M19 26v-7h7" />
    </g>
  </svg>
);
const Memo = memo(SvgCreateNote);
export default Memo;
